import React, { useState } from "react";
import DataTable from "react-data-table-component";
import "../../../../style/Realtimetracking.css";

export default function AdminRealtimeOrderTracking() {
  const [selectedOrder, setSelectedOrder] = useState<any>(null);

  const data = [
    {
      id: "TZ1001",
      location: "Delhi Clinic",
      status: "Out for Delivery",
      updatedAt: "1 hr ago",
      timeline: [
        { time: "10:00 AM", text: "Picked from lab" },
        { time: "11:00 AM", text: "Reached Sector 12" },
      ],
    },
    {
      id: "TZ1002",
      location: "Noida",
      status: "Delivered",
      updatedAt: "2 hrs ago",
      timeline: [
        { time: "09:00 AM", text: "Picked" },
        { time: "10:00 AM", text: "In Transit" },
        { time: "12:00 PM", text: "Delivered" },
          { time: "09:00 AM", text: "Picked" },
        { time: "10:00 AM", text: "In Transit" },
        { time: "12:00 PM", text: "Delivered" },  { time: "09:00 AM", text: "Picked" },
        { time: "10:00 AM", text: "In Transit" },
        { time: "12:00 PM", text: "Delivered" },  { time: "09:00 AM", text: "Picked" },
        { time: "10:00 AM", text: "In Transit" },
   
      ],
    },
  ];

  const getStatusIcon = (status: string) => {
    if (status.includes("Delivered")) return "bi-check-circle-fill text-success";
    if (status.includes("Transit")) return "bi-truck text-warning";
    if (status.includes("Picked")) return "bi-box-seam text-primary";
    return "bi-clock text-secondary";
  };

  const columns = [
    {
      name: "Order ID",
      cell: (row: any) => (
        <span><i className="bi bi-hash"></i> {row.id}</span>
      ),
    },
    {
      name: "Location",
      width:"220px",
      cell: (row: any) => (
        <span><i className="bi bi-geo-alt-fill text-danger"></i> {row.location}</span>
      ),
    },
    {
      name: "Status",
      cell: (row: any) => (
        <span className="badge bg-light text-dark border">
          <i className={`bi ${getStatusIcon(row.status)} me-1`}></i>
          {row.status}
        </span>
      ),
     width:"170px"
    },
    {
      name: "Updated",
     
      cell: (row: any) => (
        <span><i className="bi bi-clock"></i> {row.updatedAt}</span>
      ),
    },
  ];

  return (
    <div className="container">


      <div className="d-flex justify-content-between  mb-3">
        <h4 className="mb-4 text-left">
         
          Real Time  Tracking
        </h4>
      </div>


      <div className="shadow-container rounded p-3 mt-4">
      <DataTable
        columns={columns}
        data={data}
        pagination
        highlightOnHover
        pointerOnHover
        onRowClicked={(row: any) => setSelectedOrder(row)}
      />

   {selectedOrder && (
  <div className="modal fade show d-block modal-bg">
    <div className="modal-dialog modal-lg modal-dialog-centered tracking-custom-modal-popup modal-dialog-scrollable">
      <div className="modal-content premium-modal">

        {/* HEADER */}
        <div className="modal-header custom-header">
          <div>
            <h5 className="modal-title mb-1 d-flex gap-2">
              <i className="bi bi-box-seam text-primary"></i>
              {selectedOrder.id}
            </h5>
            <small className="text-muted d-flex align-items-center gap-1">
              <i className="bi bi-clock"></i> {selectedOrder.updatedAt}
            </small>
          </div>

       
          <button   onClick={() => setSelectedOrder(null)} className="custom-close-btn btn-close "><i className="bi bi-x customcross"></i></button>
        </div>

        {/* BODY */}
        <div className="modal-body px-2 py-3">

          {/* SUMMARY */}
          <div className="row g-3 mb-2">

            <div className="col-md-4">
              <div className="info-box">
                <i className="bi bi-geo-alt-fill icon red"></i>
                <div>
                  <small>Location</small>
                  <div className="fw-semibold">{selectedOrder.location}</div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-box">
                <i className="bi bi-truck icon yellow"></i>
                <div>
                  <small>Status</small>
                  <div className="fw-semibold status-text-section">{selectedOrder.status}</div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-box">
              <i className="bi bi-person-check-fill blue"></i>
                <div>
                  <small>Agent</small>
                  <div className="fw-semibold">Assigned</div>
                </div>
              </div>
            </div>

          </div>

          {/* TIMELINE HEADER */}
          <h6 className="timeline-title pb-3">
            <i className="bi bi-map me-2 py-2"></i>
            Tracking Timeline
          </h6>

      <ul className="timeline-list">
  {selectedOrder?.timeline?.map((t: any, i: number) => {
    const isLast = i === selectedOrder.timeline.length - 1;

    return (
      <li key={i} className="timeline-item">

        {/* LEFT ICON */}
        <div className={`timeline-icon ${isLast ? "active" : ""}`}>
          <i className={`bi ${isLast ? "bi-check-circle-fill" : "bi-circle"}`}></i>
        </div>

        {/* CARD */}
        <div className={`timeline-card ${isLast ? "highlight" : ""}`}>
          <div className="d-flex justify-content-between align-items-center">

            {/* TIME */}
            <div className="time">
              <i className="bi bi-clock me-1"></i>
              {t.time}
            </div>

            {/* STATUS */}
            <div className="status-badge">
              {t.text}
            </div>

          </div>
        </div>

      </li>
    );
  })}
</ul>

        </div>

      

      </div>
    </div>
  </div>
)}
</div>
    </div>
  );
}

